import { PromoCodeType } from '../app/Common/Enum/PromoCodeType';
import AppData from './AppData';
import MerchantAppData from "./MerchantAppData";

export const ServiceChargeMode = {
    Percent: "percent",
    Value: "value",
    CustomPercent: "CustomPercent",
    CustomValue: "CustomValue",
    Reset: "reset",
}

export class ServiceChargeOption {
    mode = ServiceChargeMode.Percent
    integer = "0"
    decimal = "0"
}

export const BillStatus = {
    CANCELLED: 0,
    OPEN: 1,
    CLOSED: 2,
    WAITING_PICKUP: 3,
    CASH_ON_DELIVERY: 4,
    CLOSED_VOID: 10,
}
export class Bill {
    // JS "switch" is type strict and need exact comparison for each case
    // so we need to use String value to avoid inconsistent "conversion error"
    static ROUND_NEAREST_5_CENT      = "0.05"
    static ROUND_NEAREST_10_CENT     = "0.10"
    static ROUND_NEAREST_20_CENT     = "0.20"
    static ROUND_NEAREST_50_CENT     = "0.50"
    static ROUND_NEAREST_100_CENT    = "1.00"

    static getRoundingDivisor(roundTo) {
        roundTo = parseFloat(roundTo).toFixed(2)
        switch (roundTo) {
            case Bill.ROUND_NEAREST_5_CENT:
            case Bill.ROUND_NEAREST_10_CENT:
            case Bill.ROUND_NEAREST_20_CENT:
            case Bill.ROUND_NEAREST_50_CENT:
            case Bill.ROUND_NEAREST_100_CENT:
                return Math.round(1 / roundTo)
        }
        return 20   // Default round to 5 cents
    }

    static void(billId, callback) {
        $.ajax({
            url     : `/merchant/api/bill/${billId}/void`,
            type    : 'post',
            data    : {},
            success : (res) => {

            }
        })
        .always(() => {
            callback && callback()
        })
        .fail(ajaxFails)
    }
    static delete(billId, callback, errorCallback) {
        $.ajax({
            url     : `/merchant/api/bill/${billId}/delete`,
            type    : 'post',
            data    : {},
            success : (res) => {

            }
        })
        .always(() => {
            callback && callback()
        })
        .fail(() => {
            ajaxFails()
            errorCallback && errorCallback()
        })
    }
    static calculateBillDetailsForOrder({
        orders, isHasTax, pickupTime = null, serviceCharge = 0,
        extraSCstart = null, extraSCend = null, extraSCName = null, extraSCValue = 0,
        deliveryCharge = 0, promoCode = null, extraCharge = 0, otherDiscount = 0, otherDiscountType = null,
        roundTo = Bill.ROUND_NEAREST_5_CENT,
    }) {
        deliveryCharge = deliveryCharge ? deliveryCharge : 0
        let subtotal = orders.length == 0 ? 0 : orders.map((order) => (order.order_status == "void" ? 0 : order.order_total))
                .reduce((order1, order2) => {return (parseFloat(order1) || 0) + (parseFloat(order2) || 0)}, 0)

        let discount = {}
        discount.percent = 0
        discount.value = 0
        discount.isFOC = false
        discount.integer = 0
        discount.decimal = 0

        let totalAfterDiscount = subtotal
        let promoCodeDiscount = 0
        let promoCodeDeliveryDiscount = 0
        let promoCodeDiscountHere = 0
        if (promoCode && promoCode.data && Array.isArray(promoCode.data)) {
            // We can have multiple discount mode embedded into single PromoCode,
            // example "Discount 5%" + "Free Delivery".
            // Handle it one by one
            for (let i = 0; i < promoCode.data.length; i++) {
                let promoCodeDiscountData = promoCode.data[i]
                if (promoCodeDiscountData) {
                    const discountType = promoCodeDiscountData.type || PromoCodeType.DISCOUNT_ABSOLUTE
                    let minimumPurchase = parseFloat(promoCodeDiscountData.minimum_purchase_value || 0)
                    if (subtotal >= minimumPurchase) {
                        if (discountType == PromoCodeType.DISCOUNT_ABSOLUTE) {
                            promoCodeDiscountHere = parseFloat(promoCodeDiscountData.discount_value)
                            promoCodeDiscount += promoCodeDiscountHere
                            discount.value = promoCodeDiscount
                            totalAfterDiscount += discount.value * -1
                        }
                        else if (discountType == PromoCodeType.DISCOUNT_PERCENT) {
                            const promoCodeDiscountPercent = parseFloat(promoCodeDiscountData.discount_value) * 0.01
                            promoCodeDiscountHere = subtotal * promoCodeDiscountPercent
                            if (promoCodeDiscountData.discount_max_value && promoCodeDiscountData.discount_max_value != 0) {
                                const maxDiscount = parseFloat(promoCodeDiscountData.discount_max_value)
                                promoCodeDiscountHere = promoCodeDiscountHere > maxDiscount ? maxDiscount : promoCodeDiscountHere
                            }
                            promoCodeDiscount += promoCodeDiscountHere
                            discount.value = promoCodeDiscount
                            totalAfterDiscount += discount.value * -1
                        }
                        else if (discountType == PromoCodeType.DELIVERY_DISCOUNT) {
                            if (deliveryCharge) {
                                promoCodeDeliveryDiscount = parseFloat(promoCodeDiscountData.discount_value)
                                if (deliveryCharge && deliveryCharge < promoCodeDeliveryDiscount) {
                                    promoCodeDeliveryDiscount = deliveryCharge
                                }
                            }
                        }
                        else if (discountType == PromoCodeType.FREE_ITEM) {
                            if (promoCodeDiscountData.category_id) {
                                let orders = (AppData.data.state.orders || []).filter((order) => order.order_status != "cancelled")
                                let lastHighestOrderTotalPerItem = 0
                                for (let j = 0; j < orders.length; j++) {
                                    let order = orders[j]
                                    let orderTotalPerItem = parseFloat(order.order_total) / order.quantity
                                    if (order.getCategory().id == promoCodeDiscountData.category_id) {
                                        if (!lastHighestOrderTotalPerItem) {
                                            lastHighestOrderTotalPerItem = orderTotalPerItem
                                        }
                                        else if (orderTotalPerItem > lastHighestOrderTotalPerItem) {
                                            lastHighestOrderTotalPerItem = orderTotalPerItem
                                        }
                                    }
                                }
                                if (lastHighestOrderTotalPerItem) {
                                    promoCodeDiscountHere = lastHighestOrderTotalPerItem
                                    if (promoCodeDiscountData.discount_max_value && promoCodeDiscountData.discount_max_value != 0) {
                                        const maxDiscount = parseFloat(promoCodeDiscountData.discount_max_value)
                                        promoCodeDiscountHere = promoCodeDiscountHere > maxDiscount ? maxDiscount : promoCodeDiscountHere
                                    }
                                    promoCodeDiscount += promoCodeDiscountHere
                                    discount.value = promoCodeDiscount
                                    totalAfterDiscount += discount.value * -1
                                }
                            }
                        }
                    }
                }
            }
        }

        let tax = isHasTax ? Math.round(totalAfterDiscount * 0.06 * 100) / 100.00 : 0
        let extraService = 0
        let extraServicePercent = 0
        let today = null
        if (pickupTime && typeof pickupTime === 'string') {
            today = moment(pickupTime, "YYYY-MM-DD hh:mm a").startOf('day').add(1,'second')
        }
        else if (pickupTime) {
            today = moment(pickupTime).startOf('day').add(1,'second')
        }
        let momentStart = moment(extraSCstart).startOf('day')
        let momentEnd = moment(extraSCend).endOf('day')
        let compareEnd = extraSCend ? moment(extraSCend).diff(today, 'days') : null
        if (pickupTime != null) {
            if(extraSCstart != null && extraSCstart != "") {
                if ( today.isBetween(momentStart, momentEnd) || compareEnd == 0 ) {
                    extraService = extraSCValue > 0 ? Math.round(totalAfterDiscount * parseFloat(extraSCValue) * 100) / 100.00 : 0
                    extraServicePercent = extraSCValue
                }
                else if (today.isSameOrAfter(momentStart) && (extraSCend == null || extraSCend == "")) {
                    extraService = extraSCValue > 0 ? Math.round(totalAfterDiscount * parseFloat(extraSCValue) * 100) / 100.00 : 0
                    extraServicePercent = extraSCValue
                }
            }
            else if ( extraSCend != null && extraSCend != "") {
                if ( today.isBetween(momentStart, momentEnd) || compareEnd == 0 ) {
                    extraService = extraSCValue > 0 ? Math.round(totalAfterDiscount * parseFloat(extraSCValue) * 100) / 100.00 : 0
                    extraServicePercent = extraSCValue
                }
                else if(today.isSameOrBefore(momentEnd) && (extraSCstart == null || extraSCstart == "")) {
                    extraService = extraSCValue > 0 ? Math.round(totalAfterDiscount * parseFloat(extraSCValue) * 100) / 100.00 : 0
                    extraServicePercent = extraSCValue
                }
            }
            else {
                extraService = 0
            }
        }
        let service = serviceCharge > 0 ? Math.round(totalAfterDiscount * parseFloat(serviceCharge) * 100) / 100.00 : 0

        let finalBeforeOtherDiscount = totalAfterDiscount + tax + service + extraService + extraCharge
        let finalBeforeRound = finalBeforeOtherDiscount - otherDiscount

        let roundingDivisor = Bill.getRoundingDivisor(roundTo)
        let final = Math.round(finalBeforeRound * roundingDivisor) / roundingDivisor
        let rounding = final - finalBeforeRound

        // deliveryCharge is always a positive integer
        // and is a nett charge free from tax and service charge
        final = final + deliveryCharge - promoCodeDeliveryDiscount

        let bill = {}
        bill.cash = final
        bill.cash_balance = 0
        bill.subtotal = subtotal
        bill.total = final
        bill.balance = final
        bill.decimalflag = false
        bill.decimal = 0
        bill.rounding = rounding
        bill.tax = tax
        bill.hasTax = isHasTax
        bill.extra_service_charge_name = extraSCName
        bill.extra_service_charge_value = extraService
        bill.extra_service_charge_percent = parseFloat(extraServicePercent)
        bill.service_charge_percent = parseFloat(serviceCharge)
        bill.service_charge = service
        bill.discount = discount
        bill.promo_code_discount = promoCodeDiscount
        bill.promo_code_delivery_discount = promoCodeDeliveryDiscount
        bill.extra_charge = extraCharge

        // These field for calculation use and not saved to database
        bill.finalBeforeOtherDiscount = finalBeforeOtherDiscount
        return bill
    }

    static recalculateTotalByDiscount(bill) {
        let total = bill.subtotal - bill.discount.value - parseFloat(bill.other_discount || 0)

        let tax = bill.hasTax ? Math.round(total * 0.06 * 100) / 100.00 : 0
        let extraService = bill.extra_service_charge_percent > 0 ? Math.round(total * parseFloat(bill.extra_service_charge_percent) * 100) / 100.00 : 0

        let service = 0

        // Service charge is manual input from calculator
        if (bill.serviceChargeOptions) {
            if (bill.serviceChargeOptions.mode == ServiceChargeMode.CustomPercent) {
                // service_charge_percent convert from 0-100 to 0.00-1.00
                bill.service_charge_percent = Math.round(parseFloat(bill.serviceChargeOptions.integer + "." + bill.serviceChargeOptions.decimal)) / 100.00

                // From percentage, workout the final value
                service = Math.round(total * bill.service_charge_percent * 100) / 100.00
            }
            else if ([ServiceChargeMode.CustomValue, ServiceChargeMode.Value].includes(bill.serviceChargeOptions.mode)) {
                service = Math.round(parseFloat(bill.serviceChargeOptions.integer + "." + bill.serviceChargeOptions.decimal) * 100) / 100.00
            }
        }
        // Service charge is given as percentage, triggered from service charge buttons
        else if (bill.service_charge_percent) {
            service = Math.round(total * bill.service_charge_percent * 100) / 100.00
        }

        let roundTo = MerchantAppData.data.state.merchant.bill_round_to_nearest || Bill.ROUND_NEAREST_10_CENT
        let roundingDivisor = Bill.getRoundingDivisor(roundTo)
        let final = Math.round((total + tax + service + extraService) * roundingDivisor) / roundingDivisor
        let rounding = final - (total + tax + service + extraService)
        if (rounding == 0) { //To fix "-0.00" display error
            rounding = Math.round(rounding)
        }

        bill.cash = final
        bill.cash_balance = 0
        bill.balance = final
        bill.decimalflag = false
        bill.total = final
        bill.rounding = rounding
        bill.tax = tax
        bill.extra_service_charge_value = extraService
        bill.service_charge = service

        return bill
    }

    static merchantViewBill = (tableSessionId) => {
        window.open(`/merchant/preview_receipt/${tableSessionId}`)
    }
}